interface EmailLinkProps {
  email: string;
}

const EmailLink: React.FC<EmailLinkProps> = ({ email }) => (
  <a href={`mailto:${email}`} style={{ color: "inherit", textDecoration: "none" }}>
    {email}
  </a>
);

export { EmailLink };
